import { useLocation, Link } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-4 bg-background-50">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-100 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <i className="ri-emotion-sad-line text-6xl text-foreground-300 mb-4"></i>
        <h1 className="text-xl md:text-2xl font-semibold mt-6 text-foreground-950">页面未找到</h1>
        <p className="mt-2 text-base text-foreground-500 font-mono">{location.pathname}</p>
        <p className="mt-4 text-lg md:text-xl text-foreground-400">抱歉，您访问的页面不存在或已移除。</p>
        <Link
          to="/"
          className="inline-block mt-8 whitespace-nowrap px-7 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer"
        >
          返回首页
        </Link>
      </div>
    </div>
  );
}